import Breadcrumb from '~/components/Breadcrumbs/Breadcrumb';
import SearchFiltersAccordion from './SearchFiltersAccordion';

const NewReport: React.FC = () => {
  return (
    <>
      <Breadcrumb pageName='New Report' />

      <div>
        <SearchFiltersAccordion />
      </div>
    </>
  );
};

export default NewReport;
